'use client';
import React from 'react';
import styles from '../Header.module.scss';
import cx from 'classnames';
import { useScrollDirection } from '@cat-ecom/pcc-components';
import { PAGE_BREAKPOINTS, SCROLL_DIRECTION } from 'constants/common';
const MobileScrollAwareHeader = ({
  equipmentSection,
  searchSection,
  children,
  headerHeight
}: {
  equipmentSection?: React.ReactNode;
  searchSection?: React.ReactNode;
  children: React.ReactNode;
  headerHeight?: number;
}) => {
  const scrollDirection = useScrollDirection(PAGE_BREAKPOINTS.MD, headerHeight);

  const isHidden = scrollDirection === SCROLL_DIRECTION.DOWN;

  return (
    <>
      <div
        className={cx(styles['header__scroll-aware-container'], {
          [styles['header__scroll-aware-container--hidden']]: isHidden,
          [styles['header__scroll-aware-container--visible']]: !isHidden
        })}
      >
        {children}
      </div>

      <div className={styles['header__sections-container']}>
        <div
          className={cx(styles['header__search-section'], {
            [styles['header__search-section--mobile-spacing']]: isHidden
          })}
        >
          {searchSection}
        </div>

        <div
          className={cx(
            styles['header__equipment-section'],
            styles['header__scroll-aware-container'],
            {
              [styles['header__scroll-aware-container--hidden']]: isHidden,
              [styles['header__scroll-aware-container--visible']]: !isHidden
            }
          )}
        >
          {equipmentSection}
        </div>
      </div>
    </>
  );
};

export default MobileScrollAwareHeader;
